<template>
    <div class="m-viewport" id="mainView">
        <div class="logo-view">
          <h2 class="logo_1"><a href="https://www.m3guo.com/v2/" target="_blank" rel="noopener noreferrer"></a></h2>
          <!-- <h2 class="logo_2"><a href="https://www.m3guo.com/activity/202509/v-yyds/" target="_blank" rel="noopener noreferrer"></a></h2> -->
        </div>        

        <loading v-show="Loading"/>
        
        <user-info class="m-user"/>
      
        <div class="page-body" v-if="ready">
            <div class="page-wrapper">
                <!-- <exp/>
                <skin/>
                <invite/>
                <shop/> -->
                <!-- <transition name="fade" mode="out-in" appear>
                    <router-view v-if="isRouterAlive"></router-view>
                </transition> -->
                <router-view v-if="isRouterAlive"></router-view>
            </div>
        </div>
        
        <div class="page-nav">
            <router-link 
            v-for="(item,index) in router_mainfest" 
            :key = index
            v-bind:to="item.link"
            @click.native="clearScreen()"
            @mouseenter.native="clearScreen()"
            class="u-nav"
            :class="item.name" 
            active-class="active">
            {{item.title}}
            </router-link>             
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import loading from '@/components/loading.vue'

import exp from '@/views/main.exp.vue'
import skin from '@/views/skin.pack.vue'
import invite from '@/views/task.invite.vue'
import shop from '@/views/score.shop.vue'

export default {
    components: {
        loading,
        exp,
        skin,
        invite,
        shop,
    },     
    data() {
        return {
            isRouterAlive : true,
            router_mainfest : [
                {name : 'index',title : '竞技争霸',link : '/index'},
                {name : 'skin',title : '回馈福利',link : '/skin'}, 
                {name : 'invite',title : '邀请有礼',link : '/invite'},
                {name : 'shop',title : '争霸商店',link : '/shop'}, 
            ],
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },          
    computed : {
        ...mapState(['Loading'])
    },  
    props : {
        ready : {
            default : false,
        },
    },
    provide () {
        return {
            reload: this.reload
        }
    },    
    mounted(){

    },
    methods: {
        async reload () {
            this.isRouterAlive = false
            await this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
        clearScreen(){
            const vcTooltipDom = document.getElementById('vc-tooltip')
            vcTooltipDom && document.body.removeChild(vcTooltipDom)              
        },
    }        
}
</script>

<style lang="scss" scoped>
.m-viewport{
    position: relative;
    width: 750px;
    margin: 0 auto 0;
    padding-top: 1160px;
    background-repeat: no-repeat;
    background-position: center top;
    box-sizing: border-box;
    font-size: 24px;
    background-image: url(~@/assets/images/cover.jpg);
    background-color: #341e0d;
    color: #202722;
    overflow-x: hidden;
    overflow-y: hidden;
    box-shadow: rgba(0, 0 , 0 , 0.5) 1px 2px 10px;
    /* overflow-y: scroll;    */
}

.logo-view{
    display: flex;
    align-items: center;
    position: absolute;
    left: 3%;
    top: 70px;
    z-index: 3;
}

.logo-view a{
    display: block;
    width: 100%;
    height: 100%;
}

.logo-view .logo_1{
    width: 124px;
    height: 98px;
    background-image: url(~@/assets/images/logo.png);
}

.logo-view .logo_2{
    width: 109px;
    height: 106px;
    margin-left: 26px;
    background-image: url(~@/assets/images/logo_aniver.png);
}

.page-body{
    padding-top: 100px;
    padding-bottom: 180px;
    background-image: url(~@/assets/images/body.jpg);
    background-repeat: no-repeat;
    background-color: #622723;
}

.page-wrapper{
    margin-top: -186px;
}

.m-user{
    // margin-top: 50px;
    // color: #ffcc9b;
}

.page-nav {
    display: flex;
    position: fixed;
    left: 50%;
    bottom: 0;
    z-index: 4;
    transform: translateX(-50%);
    width: 750px;
    height: 120px;   
    justify-content: space-between;
    align-items: flex-end;

    .u-nav{
        width: 186px;
        height: 120px;
        font-size: 0;
        color: transparent;

        &.index{
            background-image: url(~@/assets/images/nav/1.png);

            &.active{
                background-image: url(~@/assets/images/nav/1_act.png);
            }
        }

        &.skin{
            background-image: url(~@/assets/images/nav/2.png);

            &.active{
                background-image: url(~@/assets/images/nav/2_act.png);
            }            
        }
        
        &.invite{
            background-image: url(~@/assets/images/nav/3.png);

            &.active{
                background-image: url(~@/assets/images/nav/3_act.png);
            }            
        }
        
        &.shop{
            background-image: url(~@/assets/images/nav/4.png);

            &.active{
                background-image: url(~@/assets/images/nav/4_act.png);
            }            
        }        
    }
}
</style>